import { CategoryTone } from './AssessmentFlags.types';

// TODO: Move this Beacon display copy into a shared client module or API response
// once the POC copy settles, so it does not drift from backend assessment copy.
export const flagLabels: Record<string, string> = {
  AcademicConfidence: 'Low Academic Confidence',
  AcademicStress: 'Academic Stress',
  CareerUncertainty: 'Career Uncertainty',
  FinancialStrain: 'Financial Stress',
  FoodInsecurity: 'Food Insecurity',
  NoStableHousing: 'No Stable Housing',
  SleepDisruption: 'Sleep Disruption',
};

export const categoryLabels: Record<string, string> = {
  Academic: 'Academic Momentum',
  AcademicMomentum: 'Academic Momentum',
  Academics: 'Academic Momentum',
  BasicNeeds: 'Basic Needs',
  CareerOpportunities: 'Relationship & Career',
  Financial: 'Basic Needs',
  Finances: 'Basic Needs',
  Food: 'Basic Needs',
  Housing: 'Basic Needs',
  PersonalWellness: 'Personal Wellness',
  PhysicalHealth: 'Personal Wellness',
  SleepAndWellness: 'Personal Wellness',
  StudentSuccess: 'Academic Momentum',
  WorkAndCareer: 'Relationship & Career',
  WorkCommitments: 'Relationship & Career',
};

export const categoryToneByLabel: Record<string, CategoryTone> = {
  'Academic Momentum': 'academic',
  'Basic Needs': 'basic',
  'Personal Wellness': 'wellness',
  'Relationship & Career': 'career',
};
